import Flickity from 'flickity';

document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll<HTMLElement>('.js-rlx-wgf-feat');

  sliders.forEach((elem) => {
    const section = elem.closest<HTMLElement>('.rlx-wgf-feat');
    const dotsContainer = section?.querySelector<HTMLElement>('.js-rlx-wgf-feat-dots');
    const prev = elem.querySelector<HTMLButtonElement>('.js-prev');
    const next = elem.querySelector<HTMLButtonElement>('.js-next');
    const cells = Array.from(elem.querySelectorAll<HTMLElement>('.js-slide'));

    const flickity = new Flickity(elem, {
      cellSelector: '.js-slide',
      wrapAround: false,
      cellAlign: 'left',
      prevNextButtons: false,
      pageDots: false,
      groupCells: true,
      selectedAttraction: 0.012,
      contain: true,
    });

    // Remove Flickity's tabindex — cells have links so focus is fine
    elem.removeAttribute('tabindex');

    // Equalize cell heights so prices always align regardless of description length.
    // Run after fonts are ready so text has rendered at its final size.
    function equalizeHeights() {
      cells.forEach((c) => { c.style.height = ''; });
      const max = cells.reduce((m, c) => Math.max(m, c.offsetHeight), 0);
      if (max > 0) {
        cells.forEach((c) => { c.style.height = `${max}px`; });
        flickity.resize();
      }
    }

    document.fonts.ready.then(equalizeHeights);

    // Re-equalize on resize (debounced)
    let resizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(equalizeHeights, 150);
    });

    // Build custom animated dots
    if (dotsContainer) {
      flickity.slides.forEach((_, i) => {
        const dot = document.createElement('button');
        dot.className = `rlx-wgf-feat__dot${i === 0 ? ' is-active' : ''}`;
        dot.setAttribute('aria-label', `Go to page ${i + 1}`);
        dot.addEventListener('click', () => flickity.select(i));
        dotsContainer.appendChild(dot);
      });
    }

    // Hide dots and nav when only one page
    if (flickity.slides.length <= 1) {
      if (dotsContainer) dotsContainer.hidden = true;
      prev?.setAttribute('disabled', '');
      next?.setAttribute('disabled', '');
    }

    prev?.addEventListener('click', () => flickity.previous());
    next?.addEventListener('click', () => flickity.next());

    flickity.on('change', (index) => {
      const total = flickity.slides.length;

      // Update dot highlight
      dotsContainer?.querySelectorAll<HTMLElement>('.rlx-wgf-feat__dot').forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      // Update nav disabled state
      if (index === 0) {
        prev?.setAttribute('disabled', '');
      } else {
        prev?.removeAttribute('disabled');
      }
      if (index === total - 1) {
        next?.setAttribute('disabled', '');
      } else {
        next?.removeAttribute('disabled');
      }
    });
  });
});
